import React from 'react';

export default function OrganizationDetailsCard(props) {
	// console.log('OrganizationDetailsCard', props);
	return (
		<div className="OrganizationDetailsCard">
			<div className="card">
				<div className="card-body p-5">
					<h2 className="w-50 mb-5 mx-auto text-center">
						{I18n.t('admin.org_details_card_title')}
					</h2>
					<label htmlFor="">Password</label>
					<input
						className="w-100 p-2"
						type="text"
						placeholder="Password"
					/>
					<ul className="my-2 pl-3">
						<li>{I18n.t('admin.password_uppercase')}</li>
						<li>{I18n.t('admin.password_one_num_one_special_char')}</li>
						<li>{I18n.t('admin.password_eight_char_min')}</li>
					</ul>
					<label htmlFor="">Confirm Password</label>
					<input
						className="w-100 p-2"
						type="text"
						placeholder="Confirm password"
					/>
					<hr />
					<button type="button" className="btn btn-primary float-right w-25">
						{I18n.t('save')}
					</button>
					<p className="legal-copy float-right w-25 px-2 pt-3 ">
						{I18n.t('sign_up_legal_copy')}
					</p>
				</div>
			</div>
		</div>
	);
}
